import React from 'react'
import PropTypes from 'prop-types'
import styled from 'react-emotion'
import Helmet from 'react-helmet'
import SiteMetadata from 'SiteMetadata'
import Wrapper from 'components/Wrapper'
import Hero from 'components/Hero'

export const PageContainer = styled.div`
  background: #fff;
`

export const PageHelmet = ({ name }) => (
  <Helmet
    title={`${SiteMetadata.title} - ${SiteMetadata.pages[name].title}`}
    meta={[
      { name: 'description', content: SiteMetadata.pages[name].description }
    ]}
  />
)

PageHelmet.propTypes = {
  name: PropTypes.string.isRequired
}

const Content = styled(Wrapper)`
  max-width: 933px;
  padding-bottom: 60px;
  padding-top: 60px;
`

export const BasicPage = ({ heroImage, name, children }) => (
  <PageContainer>
    <PageHelmet name={name} />
    <Hero heroImage={heroImage} title={SiteMetadata.pages[name].title} />
    <Content>{children}</Content>
  </PageContainer>
)

BasicPage.propTypes = {
  heroImage: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.object
}

export const Heading = styled.h2`
  color: #4db051;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 3.6px;
  margin-top: 60px;
  text-transform: uppercase;

  &:first-child {
    margin-top: 0;
  }
`

export const SubHeading = styled.h3`
  font-size: 18px;
  font-weight: 900;
  margin-top: 40px;

  &:first-child {
    margin-top: 0;
  }
`

export const Paragraph = styled.p`
  font-size: ${props => props.fontSize ? props.fontSize : '18px'};
  line-height: 1.5;
  margin: 20px 0 0 0;
  text-align: ${props => props.textAlign ? props.textAlign : 'left'};

  &:first-child {
    margin-top: 0;
  }

  strong {
    font-weight: 900;
  }

  a {
    color: #4db051;
    text-decoration: none;
  }
`

export const Address = styled.div`
  margin: 20px 0 0 0;

  p {
    font-size: 18px;
    line-height: 1.5;
    margin: 0;
  }

  strong {
    font-weight: 900;
  }
`



// WEBPACK FOOTER //
// ./src/components/Page/index.js